"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (obj) { return (Array.isArray(obj) || typeof obj !== 'object'); });
//# sourceMappingURL=isObject.js.map